import { createContext, useContext } from 'react';

import { StorefrontFirstMoveView } from '@zola/svc-marketplace-ts-types';

import { MappedInquiryView } from '~/types/mappedResponseTypes';
import {
  InquiryServicesFacet,
  MappedInquiryPreferencesView,
  MappedOptionFacetView,
  VendorCardView,
} from '~/types/responseTypes';
import { CouplesStorefrontDetails } from '~/types/storefrontDetails';

import { JumpMenuItem, JumpMenuSectionIds } from '../helpers/jumpMenu';

export type StorefrontDetailsValues<T = CouplesStorefrontDetails | null> = {
  storefrontDetails: T;
  inquiryServices: InquiryServicesFacet[];
  otherServices: VendorCardView[];
  plannerPackageOptions: MappedOptionFacetView[] | null;
  inquiryPreferences: MappedInquiryPreferencesView | null;
  lastInquiry: MappedInquiryView | null;
  firstMove: StorefrontFirstMoveView | null;
  jumpMenuItems: JumpMenuItem[];
  isActive: boolean;
  isUnclaimed: boolean;
  isRapidRepeat: boolean;
  setLastInquiry: (inquiry: MappedInquiryView) => void;
  dismissFirstMove: () => void;
  addJumpMenuItem: (id: JumpMenuSectionIds) => void;
};

export const StorefrontDetailsContext = createContext<StorefrontDetailsValues>({
  storefrontDetails: null,
  inquiryServices: [],
  otherServices: [],
  jumpMenuItems: [],
  plannerPackageOptions: null,
  inquiryPreferences: null,
  lastInquiry: null,
  firstMove: null,
  isActive: false,
  isUnclaimed: false,
  isRapidRepeat: false,
  setLastInquiry: () => undefined,
  dismissFirstMove: () => undefined,
  addJumpMenuItem: () => undefined,
});

export const useStorefrontDetails = <T = CouplesStorefrontDetails | null>() =>
  useContext(StorefrontDetailsContext) as StorefrontDetailsValues<T>;
